import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackSeoRelatedSearchesOnLoggedOutCategoryPageClick } from "@faire/web-api--source/events/seo/click/relatedSearchesOnLoggedOutCategoryPage";
import React, { Suspense } from "react";
import styled from "styled-components";
import { LazySearchProductsRelatedSearchSection } from "@faire/retailer/components/SearchProducts/SearchProductsRelatedSearchSection";
import { discoverSearch } from "@faire/retailer/lib/seoPaths";
import { useLoggedOutCategoryPageCurrentNavigationPath } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentNavigationPath";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
export var LoggedOutCategoryPageRelatedSearches = function() {
    var navigationPath = useLoggedOutCategoryPageCurrentNavigationPath();
    var productRelatedSearches = useLoggedOutCategoryPageCatNavResponse().data.relatedSearchTerms;
    return /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: (productRelatedSearches === null || productRelatedSearches === void 0 ? void 0 : productRelatedSearches.length) ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(StyledLazySearchProductsRelatedSearchSection, {
                        relatedSearchTerms: productRelatedSearches !== null && productRelatedSearches !== void 0 ? productRelatedSearches : [],
                        onSearchTermClick: function(searchTerm) {
                            trackSeoRelatedSearchesOnLoggedOutCategoryPageClick(navigationPath, searchTerm);
                        },
                        generateSearchTermUrl: discoverSearch,
                        leftAlign: false
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "8x"
                    })
                ]
            }) : null
        })
    });
};
var StyledLazySearchProductsRelatedSearchSection = styled(LazySearchProductsRelatedSearchSection).withConfig({
    componentId: "sc-7a2b9af-0"
})([
    "",
    "{width:100%;padding:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing("0", "2x"));
